module.exports = __webpack_public_path__ + "img/461025dc-fc25-449e-8309-d4acb7716519.14fe9b50.jpg";